import { useMocks } from '../../shared/env';
import type { ProfileGateway } from './ProfileGateway';
import { HttpProfileGateway } from './HttpProfileGateway';
import { MockProfileGateway } from './MockProfileGateway';

export const profileGateway: ProfileGateway = useMocks ? new MockProfileGateway() : new HttpProfileGateway();
export type { ProfileGateway } from './ProfileGateway';
export * from './types';
